export const OPEN_PROCESS_ENGINEERING_MODAL = "OPEN_PROCESS_ENGINEERING_MODAL";
export const CLOSE_PROCESS_ENGINEERING_MODAL = "CLOSE_PROCESS_ENGINEERING_MODAL";

export const SUBMIT_PROCESS_ENGINEERING = "SUBMIT_PROCESS_ENGINEERING";
export const SUBMIT_PROCESS_ENGINEERING_SUCCESS = "SUBMIT_PROCESS_ENGINEERING_SUCCESS";
export const SUBMIT_PROCESS_ENGINEERING_ERROR = "SUBMIT_PROCESS_ENGINEERING_ERROR";

export const SET_PROCESS_ENGINEERING_DATA = "SET_PROCESS_ENGINEERING_DATA";
export const CLEAR_PROCESS_ENGINEERING_DATA = "CLEAR_PROCESS_ENGINEERING_DATA";

export const RESET_PROCESS_ENGINEERING_EVALUATION_SUBMISISON =
  "RESET_PROCESS_ENGINEERING_EVALUATION_SUBMISISON";

export const FETCH_PROCESS_ENGINEERING_EVALUATION_STATUSES =
  "FETCH_PROCESS_ENGINEERING_EVALUATION_STATUSES";
export const FETCH_PROCESS_ENGINEERING_EVALUATION_STATUSES_SUCCESS =
  "FETCH_PROCESS_ENGINEERING_EVALUATION_STATUSES_SUCCESS";
export const FETCH_PROCESS_ENGINEERING_EVALUATION_STATUSES_ERROR =
  "FETCH_PROCESS_ENGINEERING_EVALUATION_STATUSES_ERROR";

export const OPEN_PROCESS_ENGINEERING_TABLE_MODAL =
  "OPEN_PROCESS_ENGINEERING_TABLE_MODAL";
export const CLOSE_PROCESS_ENGINEERING_TABLE_MODAL =
  "CLOSE_PROCESS_ENGINEERING_TABLE_MODAL ";

export const SHOW_PROCESS_ENGINEERING_EVALUATION_DETAILS =
  "SHOW_PROCESS_ENGINEERING_EVALUATION_DETAILS";
export const HIDE_PROCESS_ENGINEERING_EVALUATION_DETAILS = "HIDE_PROCESS_ENGINEERING_EVALUATION_DETAILS";